var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.361 17.714h-3.139l3.14 7.857H61.5v-4.714a3.15 3.15 0 0 0-3.139-3.143z",
    fill: "#899EA8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BCC4CB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.222 17.714h-26v7.857h29.14v-4.714a3.15 3.15 0 0 0-3.14-3.143zM58.361 49.143 55.222 57h3.14a3.15 3.15 0 0 0 3.138-3.143v-1.571l-3.139-3.143z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D3DAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.361 53.857v-4.714L9.5 52.286v1.571A3.15 3.15 0 0 0 12.639 57h42.583a3.15 3.15 0 0 0 3.14-3.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.361 22.428h-3.139l3.14 29.858H61.5V25.57a3.15 3.15 0 0 0-3.139-3.143z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.361 25.571a3.15 3.15 0 0 0-3.139-3.142H38.64l-4.537-6.814C33.145 14.177 30.95 13 29.222 13H12.64A3.15 3.15 0 0 0 9.5 16.143v36.143h48.861V25.57z",
    fill: "#E8EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.5 24)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 36.818C40 38.545 38.545 40 36.818 40c-.909 0-1.727-.364-2.363-1L24.273 27.91a.879.879 0 0 1 0-1.274l2.363-2.363a.879.879 0 0 1 1.273 0L39 34.545c.636.546 1 1.455 1 2.273z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0C4D8",
    d: "m26.34 24.54-1.8 1.8-2.7-2.7 1.8-1.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 25 .455.455.909-.91-2.728-2.727-1.818 1.818L23.182 25c.545-.545 1.273-.545 1.818 0z",
    fill: "#99B4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.636 0A13.618 13.618 0 0 0 0 13.636c0 7.546 6.09 13.637 13.636 13.637 7.546 0 13.637-6.091 13.637-13.637C27.273 6.091 21.182 0 13.636 0zm0 24.545c-6 0-10.909-4.909-10.909-10.909 0-6 4.91-10.909 10.91-10.909s10.908 4.91 10.908 10.91-4.909 10.908-10.909 10.908z",
    fill: "#C4D7E5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#70B7E5",
    cx: 13.909,
    cy: 13.909,
    r: 10.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.273 14.91a7.716 7.716 0 0 1 6.636-6.637H15c1.545-.182 1.636-2.364.182-2.637-.91-.181-1.818-.181-2.727-.09-3.546.545-6.364 3.363-6.819 6.818-.181.909-.09 1.909.091 2.727.273 1.545 2.455 1.364 2.637-.182-.091.091-.091 0-.091 0z",
    fill: "#92C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.636 14.545c0-6 4.91-10.909 10.91-10.909 2.818 0 5.272 1.091 7.272 2.728-2-2.273-4.909-3.637-8.182-3.637-6 0-10.909 4.91-10.909 10.91 0 3.272 1.455 6.181 3.637 8.181-1.637-2-2.728-4.454-2.728-7.273z",
    fill: "#4C9CD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.636 27.273c7.546 0 13.637-6.091 13.637-13.637a.911.911 0 0 0-.91.91c-.181 3.09-1.545 5.909-3.636 8-2.09 2.181-5 3.545-8.182 3.818a.911.911 0 0 0-.909.909z",
    fill: "#B0C9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.91 34.455 38.363 34c.454.545.727 1.273.727 2 0 1.182-1.455 1.636-2.273.818l-9.545-9.545a1.318 1.318 0 0 0-1.91 0l-.908.909 9.909 10.636c.545.546 1.272 1 2 1.091 1 .091 2-.273 2.636-.909.636-.636 1-1.636.91-2.636 0-.728-.455-1.364-1-1.91z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.545 28.182c-.09 0-.272 0-.363-.091l-2.273-2.273a.44.44 0 0 1 0-.636.44.44 0 0 1 .636 0l2.273 2.273a.44.44 0 0 1 0 .636c0 .09-.182.09-.273.09z",
    fill: "#899EA8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.036 34.464a1 1 0 0 1 0 1.415l-2.121 2.12 2.12 2.122a1 1 0 0 1-1.414 1.415L38.5 39.414l-2.121 2.122a1 1 0 0 1-1.415-1.415L37.086 38l-2.122-2.121a1 1 0 0 1 1.415-1.415l2.121 2.122 2.121-2.122a1 1 0 0 1 1.415 0z",
    fill: "#E9EFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.c13297c1.svg";
export { ForwardRef as ReactComponent };